import moment from 'moment';

export const fetchDavtTasksURL = (page, search = '', taskName, dateRange) => {
  if (taskName === 'escalated') {
    return `/customer/davt-task/?page=${page}&escalated=true${search}`;
  } else if (taskName === 'summary') {
    const startDate =
      dateRange && dateRange[0]
        ? moment(dateRange[0], 'DD-MM-YYYY', true).isValid()
          ? moment(dateRange[0], 'DD-MM-YYYY')?.format('YYYY-MM-DD')
          : ''
        : '';
    const endDate =
      dateRange && dateRange[1]
        ? moment(dateRange[1], 'DD-MM-YYYY', true).isValid()
          ? moment(dateRange[1], 'DD-MM-YYYY')?.format('YYYY-MM-DD')
          : ''
        : '';
    return `/customer/davt-task/?page=${page}&summary=true${
      startDate ? `&start_date=${startDate}` : ''
    }${endDate ? `&end_date=${endDate}` : ''}`;
  } else {
    return `/customer/davt-task/?page=${page}${search}`;
  }
};

export const fetchTaskDetailsURL = (taskId) => {
  return `/customer/davt-task/${taskId}/`;
};

export const sendTaskForApprovalURL = (actionType) => {
  return `/customer/davt-task/${actionType}/`;
};

export const submitFSQuestionnaireURL = () => {
  return `/customer/davt-task/questions/`;
};

export const toggleDavtUserStatusURL = () => {
  return `/customer/toggle-davt-employee-status/`;
};
